import { Controller } from "stimulus"
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = [ "submitMobile", "submitDesktop", 'checkbox' ]

  connect() {
    if(this.hasSubmitMobileTarget) {
      this.element.addEventListener('ajax:success', (evt) => {
        this.submitMobileTarget.disabled = true
        if(this.element.getAttribute('data-type') == 'json') {
          const count = evt.detail[0].count
          const submitValue = this.submitMobileTarget.getAttribute('data-submit-value').replace(':count', count)
          this.element.removeAttribute('data-type');
          this.submitMobileTarget.value = submitValue
          if(count > 0) {
            this.submitMobileTarget.disabled = false
          }
        }
      })
    }
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.addEventListener('change', (evt) => {
        if(this.hasSubmitMobileTarget) {
          this.element.setAttribute('data-type', 'json')
        }
        Rails.fire(this.element, 'submit');
      })
    })
  }
}
